import React from "react"
import {
    Box,
    Card,
    CardContent,
    TextField,
    Typography,
    Button,
    Divider,
    Stack,
} from "@mui/material"
import { useCreateProvisionalCertificateMutation } from "../Redux/actions/certificate.action"
import { updateFields, resetForm } from "../Redux/actions/formValue.action"
import { useSelector, useDispatch } from "react-redux"
import { Loader } from "../components/index"
import { toaster, Message } from "rsuite"
import _ from "lodash"

const ProvisionalCertificateForm = () => {
    const dispatch = useDispatch()
    const [generateProvisionalCer, generateProvisionalCerState] = useCreateProvisionalCertificateMutation()

    const formValue = useSelector(state => state.form)
    const student_name = _.get(formValue, "state.student_name", "")
    const institution_name = _.get(formValue, "state.institution_name", "")
    const class_name = _.get(formValue, "state.class_name", "")


    React.useEffect(() => {
        if (generateProvisionalCerState.isSuccess) {
            const blob = generateProvisionalCerState.data

            const url = window.URL.createObjectURL(blob)

            const a = document.createElement("a")
            a.href = url
            a.download = "Provisional_certificate.pdf"
            document.body.appendChild(a)
            a.click()

            a.remove()
            window.URL.revokeObjectURL(url)
            generateProvisionalCerState.reset()
            dispatch(resetForm())
        } else if (generateProvisionalCerState.isError) {
            toaster.push(<Message type="error" >Error while create the School Leaving certificate,Please try again later!</Message>, { placement: "topCenter" })
            generateProvisionalCerState.reset()
        }
    }, [generateProvisionalCerState.status])
    const handleSubmit = () => {
        if (
            !student_name || !class_name || !institution_name
        ) {
            toaster.push(<Message type="info">Please fill all fields value!</Message>, { placement: "topCenter" })
            return
        }
        const data = {
            student_name:student_name,
            institution:institution_name,
            course:class_name
        }
        generateProvisionalCer(data)
    }

    return (
        <Box sx={{ maxWidth: 720, mx: "auto", mt: 5 }}>
            <Card elevation={3} sx={{ borderRadius: 3 }}>
                <CardContent>
                    <Typography variant="h5" fontWeight={600}>
                        Provisional's Certificate
                    </Typography>
                    <Typography variant="body2" color="text.secondary" mb={2}>
                        Enter student and school details carefully
                    </Typography>

                    <Divider sx={{ mb: 3 }} />

                    <Stack spacing={2.5}>
                        <TextField
                            label="Student Name"
                            name="student_name"
                            fullWidth
                            placeholder="eg.Bhuban Padun"
                            value={student_name}
                            onChange={(e) => {
                                let val = e.target.value.toUpperCase()
                                dispatch(updateFields({ student_name: val }))
                            }}
                        />
                        <TextField
                            label="Institution Name"
                            name="institution_name"
                            placeholder="eg. ABC Public School"
                            fullWidth
                            value={institution_name}
                            onChange={(e) => {
                                let val = e.target.value.toUpperCase()
                                dispatch(updateFields({ institution_name: val }))
                            }}
                        />
                        <TextField
                            label="Department/ClassName/CourseName"
                            name="class_name"
                            placeholder="eg. Bachelor of Computer Science"
                            rows={2}
                            fullWidth
                            value={class_name}
                            onChange={(e) => {
                                let val = e.target.value
                                dispatch(updateFields({ class_name: val }))
                            }}
                        />
                    </Stack>

                    <Box sx={{ mt: 4, textAlign: "right" }}>
                        <Button
                            variant="contained"
                            size="large"
                            sx={{ px: 4 }}
                            onClick={handleSubmit}
                        >
                            Generate Certificate
                        </Button>
                    </Box>
                </CardContent>
            </Card>
            {
                (
                    generateProvisionalCerState.isLoading
                ) && (
                    <Loader show={true} />
                )
            }
        </Box>
    );
};

export default ProvisionalCertificateForm
